/**
 * Enum lists all available in MyDelta date formats.
 *
 * @author michaelp
 */
export enum DateFormat {
  Unix = "YYYY-MM-DD",
  American = "MM/DD/YYYY",
  European = "DD/MM/YYYY",
}

export type DateFormatType = {
  value: string;
  label: string;
};


export const dateFormatList: DateFormatType[] = [
  { label: "Unix/ISO [" + DateFormat.Unix + "]", value: DateFormat.Unix },
  { label: "US/Canada [" + DateFormat.American + "]", value: DateFormat.American },
  { label: "UK/Europe [" + DateFormat.European + "]", value: DateFormat.European }
]

export function DateFormatLookup(format: string): DateFormatType {
  var res = dateFormatList[0];

  dateFormatList.forEach(function (dt) {
    if (dt.value === format) {
      res = dt;
    }
  });

  return res;
}
